export default "__VITE_ASSET__C8UMCpzi__"